import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";

const KEY = "bevela_cookie_consent";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 rounded-2xl bg-[#0B192C] text-white p-5 shadow-2xl border border-white/10"
      data-testid="cookie-banner"
    >
      <p className="text-sm text-white/80 leading-relaxed">
        {t.cookies.text}{" "}
        <Link to="/cookies" className="underline text-[#C2A878]" data-testid="cookie-banner-more">
          {t.cookies.more}
        </Link>
      </p>
      <div className="mt-4 flex gap-3 justify-end">
        <button onClick={() => choose("essential")} className="text-sm font-display text-white/70 hover:text-white px-3 py-2" data-testid="cookie-reject">
          {t.cookies.reject}
        </button>
        <button onClick={() => choose("all")} className="text-sm font-display bg-[#C2A878] text-[#0B192C] rounded-full px-4 py-2 hover:bg-[#d4bc90] transition-colors" data-testid="cookie-accept">
          {t.cookies.accept}
        </button>
      </div>
    </div>
  );
}
